import React, { useState } from 'react';
import { Packages } from '@C/Utils';
import { authHeader } from '@H';
import axios from 'axios';
import { toast } from 'react-toastify';
import Select from 'react-select';
import ExistingPlans from './ExistingPlans';

const sortOptions = [
  { value: '', label: ' Select subscription plan days', isDisabled: true },
  { value: 'TRIAL', label: 'Trial' },
  { value: 'MONTHLY', label: 'Monthly - (30 days)' },
  { value: 'QUARTERLY', label: 'Quarterly - (90 days)' },
  { value: 'YEARLY', label: 'Yearly - (365 days)' },
];

const Plans = () => {
  const [packageName, setPackageName] = useState({
    plan_id: '',
    plan_type: '',
    price: '',
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [updated, setUpdated] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setPackageName((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleSortOrderChange = (e) => {
    setPackageName((prevState) => ({
      ...prevState,
      plan_type: e.value,
    }));
  };

  const handlePackageChange = (e) => {
    setPackageName((prevState) => ({
      ...prevState,
      plan_id: e?.value || '',
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    const headers = authHeader(1);
    axios
      .post(
        `${process.env.API_URL}/subscription/create-subscription-plan/`,
        packageName,
        {
          headers,
        },
      )
      .then(() => {
        toast.success('Plan added successfully', {
          position: 'bottom-center',
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        setPackageName({
          plan_id: '',
          plan_type: '',
          price: '',
        });
        setIsSubmitting(false);
        setUpdated((prev) => !prev);
      })
      .catch((err) => {
        toast.error(err.response?.data?.message, {
          position: 'bottom-center',
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        setIsSubmitting(false);
      });
  };

  return (
    <>
      <section className="widget full-width form-table">
        <header>
          <h3> Add new plan </h3>
        </header>
        <div className="packages-container">
          <form className="full-width">
            <div className="input-wrapper">
              <label>Select the package :</label>
              <Packages
                handlePackageChange={handlePackageChange}
                value={packageName.plan_id}
              />
            </div>
            <div className="input-wrapper">
              <label>Set price</label>
              <input
                type="text"
                onChange={handleChange}
                value={packageName.price}
                name="price"
              />
            </div>
            <div className="input-wrapper">
              <label>Select plan:</label>
              <Select
                name="sort_order"
                options={sortOptions}
                onChange={handleSortOrderChange}
                value={sortOptions.find(
                  ({ value }) => value === packageName.plan_type,
                )}
                placeholder="Select subscription plan days"
              />
            </div>
            <div className="cta-wrapper">
              <button
                className="submit"
                type="submit"
                disabled={isSubmitting}
                onClick={handleSubmit}
              >
                {isSubmitting ? 'Saving...' : 'Save'}
              </button>
            </div>
          </form>
        </div>
      </section>
      <ExistingPlans key={updated} />
    </>
  );
};

export { Plans };
